import { ref } from 'vue'

export default function useUrlPresetFilters(resource) {
    const filterPreset = ref({ value: false, type: null, information: null });

    function applyPresetFiltersFromURL() {
        const queryParams = new URLSearchParams(window.location.search);
        const filterParam = queryParams.get('filter');
        if  (resource === 'users') {
            if(filterParam === 'Warning') {
                filterPreset.value = { value: true, type: filterParam, information: '(Users Over 80% Usage)' };
            } else if(filterParam === 'Capped') {
                filterPreset.value = { value: true, type: filterParam, information: '(Capped Users)' };
            }
        } else if (resource === 'sims') {
            if(filterParam === 'Unassigned') {
                filterPreset.value = { value: true, type: filterParam, information: '(Unassigned)' };
            } else if (filterParam === 'Zero') {
                filterPreset.value = { value: true, type: filterParam, information: '(Zero MB usage over last 3 months)' };
            } else if (filterParam === '1_HOUR') {
                filterPreset.value = { value: true, type: filterParam, information: '(Active in last hour)' };
            } else if (filterParam === '24_HOUR') {
                filterPreset.value = { value: true, type: filterParam, information: '(Active in last 24 hours)' };
            } else if(filterParam === 'MONTHLY_ACTIVE') {
                filterPreset.value = { value: true, type: filterParam, information: '(Active this month)' };
            } else if(filterParam === 'MONTHLY_INACTIVE') {
                filterPreset.value = { value: true, type: filterParam, information: '(Inactive this month)' };
            }
        }
    }

    function removePresetFilters() {
        if (filterPreset.value) {
            filterPreset.value = { value: false, type: null, information: null };
        }
    }

    return { filterPreset, applyPresetFiltersFromURL, removePresetFilters };
}
